"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    dialog: (0, _defineProperty2.default)({
      padding: theme.spacing(1)
    }, theme.breakpoints.down('xs'), {
      margin: 0,
      width: 'calc(100% - 16px)'
    }),
    content: {},
    header: {
      width: '100%',
      paddingBottom: theme.spacing(1),
      display: 'flex',
      alignItems: 'center'
    },
    title: {},
    iconBtn: {}
  };
}, {
  name: 'DialogWithTitle'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_Close.default, null);

function DialogWithTitle(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      handleChange = _ref.onChange,
      openDialog = _ref.openDialog,
      title = _ref.title,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "onChange", "openDialog", "title"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, (0, _extends2.default)({}, rest, {
    open: openDialog,
    onClose: handleChange(undefined),
    className: classes.root,
    classes: {
      paper: classes.dialog
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.header,
    style: {
      justifyContent: title ? 'space-between' : 'flex-end'
    }
  }, title && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body1",
    className: classes.title
  }, title), /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    className: classes.iconBtn,
    onClick: handleChange(undefined)
  }, _ref2)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.content
  }, children));
}

process.env.NODE_ENV !== "production" ? DialogWithTitle.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    content: _propTypes.default.string,
    dialog: _propTypes.default.string,
    header: _propTypes.default.string,
    iconBtn: _propTypes.default.string,
    root: _propTypes.default.string,
    title: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  onChange: _propTypes.default.func,
  openDialog: _propTypes.default.bool,
  title: _propTypes.default.string
} : void 0;
DialogWithTitle.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined,
  onChange: undefined,
  openDialog: false,
  title: undefined
};
var _default = DialogWithTitle;
exports.default = _default;